import * as Immutable from 'immutable';

export interface IViewProductGpsrManufacturerStore {
	id: number
	name: string
	ca_number: string | null
	address: string | null
}

const defaultViewProductGpsrManufacturerStore = Immutable.Record<IViewProductGpsrManufacturerStore>({
	id: 0,
	name: '',
	ca_number: null,
	address: null,
});

export default class ViewProductGpsrManufacturerStore extends defaultViewProductGpsrManufacturerStore implements IViewProductGpsrManufacturerStore {}
